import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import Es6Promise from 'es6-promise'
// import VClamp from 'vue-clamp'
import * as filters from '@/filters'
import echarts from 'echarts'
import moment from 'moment'
import '@/plugins/element.js'
import '@/common/element-ui-theme/index.css'
import '@/plugins/iview.js'
import '@/common/css/index.less'
import '@/components/global/index'
import i18n from '@/plugins/i18n'
import big from 'big.js'

// 注册全局指令
import vueVerify from './directive/vue-better-verify'
// 加载通用的通讯方法 $sender $receiver
import { $sender, $receiver } from 'vue-communication'

import VuCountryIntl from 'vue-country-intl'
import 'vue-country-intl/lib/vue-country-intl.css'

Es6Promise.polyfill()
Vue.use(vueVerify, {
  regExp: {
    password: /^(?=.*\d)(?=.*[A-z])[\w_]{8,18}$/
  }
})

Vue.component(VuCountryIntl.name, VuCountryIntl)
// Vue.component('VClamp', VClamp) // 多行省略组件

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.prototype.$echart = echarts
Vue.prototype.$moment = moment
Vue.prototype.$sender = $sender
Vue.prototype.$receiver = $receiver
Vue.prototype.$big = big

Vue.config.productionTip = false

export const vm = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
